import _ from 'lodash';
import {useEffect, useState} from 'react';
import React from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router';
import REST from 'go/requests/rest';
import {
  Card,
  Grid,
  Item,
  ItemGroup,
  Loader,
  Menu,
  Tab,
  Dropdown,
  Radio,
  Pagination,
} from 'semantic-ui-react';
import {Alert} from 'app-ui-componentlibrary/dist/componentLibrary/layout';

export const FemaWorkCard = (props) => {
  const [panes, setPanes] = useState([]);
  const [redirect, setRedirect] = useState(null);
  const [activeItem, setActiveItem] = useState('Date in queue');
  const [sortingDirection, setSortingDirection] = useState('Ascending');
  const [activePage, setActivePage] = useState(1);
  const [activeItemSaveLater, setActiveItemSaveLater] = useState('Date in queue');
  const [sortingDirectionSaveLater, setSortingDirectionSaveLater] = useState('Ascending');
  const [
    removeSavedForLaterAlertMessageId,
    setRemoveSavedForLaterAlertMessageId,
  ] = useState('');

  const {
    fundingOpportunities,
    retrieveUserSavedForLater,
    loading,
    signedFOs,
    assignedOpenTasks,
    userSavedForLater,
    assignee,
    toggles,
    isSMAUserorSPGAUser,
  } = props;

  const totalAssignedTasks = assignedOpenTasks.length;
  const totalSavedForLaterTasks = userSavedForLater.length;
  const openTasks = 'open tasks';
  const saveForLater = 'save for later';

  useEffect(() => {
    let assignedOpenTasksEditable = sortAssignedTasks();
    let savedForLaterTasks = filterSavedForLater(activePage);
    let disasterSiteNav = _.includes(toggles, 'disasterSiteNav');
    let pane = [
      {
        menuItem: (
          <Menu.Item key="myFundingOpportunities" className="menu-item">
            My funding opportunities ({_.size(fundingOpportunities)})
          </Menu.Item>
        ),
        render: () => (
          <Tab.Pane
            attached={false}
            style={{border: 'none', 'box-shadow': 'none', padding: '14px 0'}}
          >
            {loading ? (
              <Loader active />
            ) : (
              <Item.Group divided>
                {_.size(fundingOpportunities) > 0 ? (
                  _.map(fundingOpportunities, (fo, index) => {
                    const isDraft =
                      _.get(fo, 'status', '') === 'draft' &&
                      !_.includes(signedFOs, fo.fundingOpportunityId);
                    const viewLinkTitle = `View funding opportunity: ${_.get(
                      fo,
                      'fundingOpportunityName',
                      ''
                    )}`;
                    const viewLinkHref = `/fundingOpportunity/${fo.fundingOpportunityId}`;
                    const continueLinkTitle = `Continue funding opportunity: ${_.get(
                      fo,
                      'fundingOpportunityName',
                      ''
                    )}`;
                    const continueLinkHref = `/fundingOpportunity/draft/${fo.id}`;

                    return (
                      <Item
                        key={index}
                        className="homepage my-funding-opportunities-content"
                      >
                        <Item.Content>
                          <h4 style={{marginBottom: 0}}>
                            {disasterSiteNav ? (
                              <a
                                key={`link-${fo.fundingOpportunityName}`}
                                href="#"
                                title={viewLinkTitle}
                                onClick={(e) => {
                                  e.preventDefault();
                                  new Promise((resolve) => resolve()).then(() => {
                                    setRedirect(viewLinkHref);
                                  });
                                }}
                              >
                                {_.get(fo, 'fundingOpportunityName', '')}
                              </a>
                            ) : (
                              _.get(fo, 'fundingOpportunityName', '')
                            )}
                          </h4>
                          <div>
                            Program name:{' '}
                            <span className="homepage-details">
                              {_.get(fo, 'programName', '')}
                            </span>
                          </div>
                          {!!fo.fundingOpportunityId && !disasterSiteNav && (
                            <>
                              <a
                                key={`link-${fo.fundingOpportunityName}`}
                                href="#"
                                title={viewLinkTitle}
                                onClick={(e) => {
                                  e.preventDefault();
                                  new Promise((resolve) => resolve()).then(() => {
                                    setRedirect(viewLinkHref);
                                  });
                                }}
                              >
                                View
                              </a>
                              {!!fo.fundingOpportunityId && isDraft && (
                                <>&nbsp;&nbsp;|&nbsp;&nbsp;</>
                              )}
                            </>
                          )}
                          {isDraft && isSMAUserorSPGAUser && (
                            <a
                              key={`link-${fo.fundingOpportunityName}`}
                              href="#"
                              title={continueLinkTitle}
                              onClick={(e) => {
                                e.preventDefault();
                                new Promise((resolve) => resolve()).then(() => {
                                  setRedirect(continueLinkHref);
                                });
                              }}
                            >
                              Continue Draft
                            </a>
                          )}
                        </Item.Content>
                      </Item>
                    );
                  })
                ) : (
                  <p style={{fontWeight: 400}}>
                    There are no funding opportunity actions.
                  </p>
                )}
              </Item.Group>
            )}
          </Tab.Pane>
        ),
      },
    ];

    if (_.includes(toggles, 'disasterSiteNav'))
      pane.push(
        {
          menuItem: (
            <Menu.Item key="myOpenTasks" className="menu-item">
              My open tasks ({totalAssignedTasks})
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane
              attached={false}
              style={{border: 'none', 'box-shadow': 'none', padding: '14px 0'}}
            >
              {loading ? (
                <Loader active />
              ) : (
                <div>
                  {totalAssignedTasks > 0 ? (
                    <div>
                      <Menu borderless secondary>
                        <Dropdown
                          item
                          text={`Sort by: ${activeItem}`}
                          style={{'padding-left': 0}}
                        >
                          <Dropdown.Menu>
                            <Dropdown.Item
                              name="Task"
                              active={activeItem === 'Task'}
                              onClick={() => handleItemClick('Task', openTasks)}
                            >
                              Task
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Funding opportunity name"
                              active={activeItem === 'Funding opportunity name'}
                              onClick={() =>
                                handleItemClick('Funding opportunity name', openTasks)
                              }
                            >
                              Funding opportunity name
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Organization"
                              active={activeItem === 'Organization'}
                              onClick={() => handleItemClick('Organization', openTasks)}
                            >
                              Organization
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Suborganization"
                              active={activeItem === 'Suborganization'}
                              onClick={() =>
                                handleItemClick('Suborganization', openTasks)
                              }
                            >
                              Suborganization
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Date in queue"
                              active={activeItem === 'Date in queue'}
                              onClick={() => handleItemClick('Date in queue', openTasks)}
                            >
                              Date in queue
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Grant ID"
                              active={activeItem === 'Grant ID'}
                              onClick={() => handleItemClick('Grant ID', openTasks)}
                            >
                              Grant ID
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Subgrant ID"
                              active={activeItem === 'Subgrant ID'}
                              onClick={() => handleItemClick('Subgrant ID', openTasks)}
                            >
                              Subgrant ID
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Priority Rank"
                              active={activeItem === 'Priority Rank'}
                              onClick={() => handleItemClick('Priority Rank', openTasks)}
                            >
                              Priority Rank
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <Menu.Menu>
                          <Radio
                            className="homepageRadioBtn"
                            name="Ascending"
                            value="Ascending"
                            label="Ascending (A-Z)"
                            title="Ascending"
                            checked={sortingDirection === 'Ascending'}
                            onClick={() => handleDirectionChange('Ascending', openTasks)}
                          />
                          <Radio
                            className="homepageRadioBtn"
                            name="Descending"
                            value="Descending"
                            label="Descending (Z-A)"
                            title="Descending"
                            checked={sortingDirection === 'Descending'}
                            onClick={() => handleDirectionChange('Descending', openTasks)}
                          />
                        </Menu.Menu>
                      </Menu>
                      <a
                        href="#"
                        title={'My open tasks'}
                        onClick={(e) => {
                          e.preventDefault();
                          new Promise((resolve) => resolve()).then(() => {
                            setRedirect(`tasks/list?assignee=${assignee}`);
                          });
                        }}
                      >
                        View all my open tasks ({totalAssignedTasks})
                      </a>
                      <ItemGroup divided>
                        {_.map(assignedOpenTasksEditable, (task, index) => {
                          const continueLinkTitle =
                            `Continue working task for: ${_.get(task, 'grantId', '')} ` +
                            `${_.get(task, 'name')}`;
                          const continueLinkHref = `/tasks/${task.id}`;
                          const matchFundOpp = _.find(
                            fundingOpportunities,
                            (fundingOpportunity) => {
                              return (
                                fundingOpportunity.fundingOpportunityId ==
                                task.fundingOpportunityId
                              );
                            }
                          );
                          const fundOppName = _.get(
                            matchFundOpp,
                            'fundingOpportunityName',
                            ''
                          );
                          const viewLinkTitle = `View funding opportunity: ${fundOppName}`;
                          const viewLinkHref = `/fundingOpportunity/${matchFundOpp?.fundingOpportunityId}`;
                          const viewLinkTitleOrg = `View Organization Info: ${task.organizationName}`;
                          const viewLinkHrefOrg = `/organizationProfile/${task.organizationId}`;
                          const viewLinkTitleSubOrg = `View Sub Organization Info: ${task.subOrganizationName}`;
                          const viewLinkHrefSubOrg = `/organizationProfile/${task.subOrgId}`;
                          return (
                            <Item
                              key={index}
                              className="homepage my-funding-opportunities-content"
                            >
                              <Item.Content>
                                <h4 style={{marginBottom: 3}}>
                                  <a
                                    key={`link-${
                                      task.fundingOpportunityName != null
                                        ? task.fundingOpportunityName
                                        : fundOppName
                                    }`}
                                    href="#"
                                    title={viewLinkTitle}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then(() => {
                                        setRedirect(viewLinkHref);
                                      });
                                    }}
                                  >
                                    {task.fundingOpportunityName != null
                                      ? task.fundingOpportunityName
                                      : fundOppName}
                                  </a>
                                </h4>
                                <div>
                                  Task:{' '}
                                  <span className="homepage-details">
                                    <a
                                      key={`link-${task.id}`}
                                      href="#"
                                      title={continueLinkTitle}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        new Promise((resolve) => resolve()).then(() => {
                                          setRedirect(continueLinkHref);
                                        });
                                      }}
                                    >
                                      {_.get(task, 'name', '')}
                                    </a>
                                  </span>
                                </div>
                                {task.subGrantId
                                  ? 'Subgrant ID: '
                                  : task.payload &&
                                    task.payload.scopeOfWork &&
                                    task.payload.scopeOfWork.proposedActivityTitle
                                  ? 'Title: '
                                  : 'Grant ID: '}
                                <span className="homepage-details">
                                  {task.subGrantId
                                    ? task.subGrantId
                                    : task.payload &&
                                      task.payload.scopeOfWork &&
                                      task.payload.scopeOfWork.proposedActivityTitle
                                    ? task.payload.scopeOfWork.proposedActivityTitle
                                    : task.grantId}
                                </span>
                                <br />
                                <div>
                                  Recipient:{' '}
                                  <a
                                    key={`link-${task.organizationId}`}
                                    href="#"
                                    title={viewLinkTitleOrg}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then(() => {
                                        setRedirect(viewLinkHrefOrg);
                                      });
                                    }}
                                  >
                                    <span className="homepage-details">
                                      {_.get(task, 'organizationName', '')}
                                    </span>
                                  </a>
                                </div>
                                {task.subOrgId !== undefined ? (
                                  <div>
                                    Subrecipient:{' '}
                                    <a
                                      key={`link-${task.subOrgId}`}
                                      href="#"
                                      title={viewLinkTitleSubOrg}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        new Promise((resolve) => resolve()).then(() => {
                                          setRedirect(viewLinkHrefSubOrg);
                                        });
                                      }}
                                    >
                                      <span className="homepage-details">
                                        {_.get(task, 'subOrganizationName', '')}
                                      </span>
                                    </a>
                                  </div>
                                ) : (
                                  ''
                                )}
                              </Item.Content>
                            </Item>
                          );
                        })}
                      </ItemGroup>
                    </div>
                  ) : (
                    <p style={{fontWeight: 400}}>There are no pending tasks</p>
                  )}
                </div>
              )}
            </Tab.Pane>
          ),
        },
        {
          menuItem: (
            <Menu.Item key="savedForLater" className="menu-item">
              Saved for later ({totalSavedForLaterTasks})
            </Menu.Item>
          ),
          render: () => (
            <Tab.Pane
              attached={false}
              style={{border: 'none', 'box-shadow': 'none', padding: '14px 0'}}
            >
              {loading ? (
                <Loader active />
              ) : (
                <div>
                  {totalSavedForLaterTasks > 0 ? (
                    <div>
                      <Menu borderless secondary>
                        <Dropdown
                          item
                          text={`Sort by: ${activeItemSaveLater}`}
                          style={{'padding-left': 0}}
                        >
                          <Dropdown.Menu>
                            <Dropdown.Item
                              name="Task"
                              active={activeItemSaveLater === 'Task'}
                              onClick={() => handleItemClick('Task', saveForLater)}
                            >
                              Task
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Funding opportunity name"
                              active={activeItemSaveLater === 'Funding opportunity name'}
                              onClick={() =>
                                handleItemClick('Funding opportunity name', saveForLater)
                              }
                            >
                              Funding opportunity name
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Organization"
                              active={activeItemSaveLater === 'Organization'}
                              onClick={() =>
                                handleItemClick('Organization', saveForLater)
                              }
                            >
                              Organization
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Suborganization"
                              active={activeItemSaveLater === 'Suborganization'}
                              onClick={() =>
                                handleItemClick('Suborganization', saveForLater)
                              }
                            >
                              Suborganization
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Date in queue"
                              active={activeItemSaveLater === 'Date in queue'}
                              onClick={() =>
                                handleItemClick('Date in queue', saveForLater)
                              }
                            >
                              Date in queue
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Grant ID"
                              active={activeItemSaveLater === 'Grant ID'}
                              onClick={() => handleItemClick('Grant ID', saveForLater)}
                            >
                              Grant ID
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Subgrant ID"
                              active={activeItemSaveLater === 'Subgrant ID'}
                              onClick={() => handleItemClick('Subgrant ID', saveForLater)}
                            >
                              Subgrant ID
                            </Dropdown.Item>
                            <Dropdown.Item
                              name="Priority Rank"
                              active={activeItemSaveLater === 'Priority Rank'}
                              onClick={() =>
                                handleItemClick('Priority Rank', saveForLater)
                              }
                            >
                              Priority Rank
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <Menu.Menu>
                          <Radio
                            className="homepageRadioBtn"
                            name="Ascending"
                            value="Ascending"
                            label="Ascending (A-Z)"
                            title="Ascending"
                            checked={sortingDirectionSaveLater === 'Ascending'}
                            onClick={() =>
                              handleDirectionChange('Ascending', saveForLater)
                            }
                          />
                          <Radio
                            className="homepageRadioBtn"
                            name="Descending"
                            value="Descending"
                            label="Descending (Z-A)"
                            title="Descending"
                            checked={sortingDirectionSaveLater === 'Descending'}
                            onClick={() =>
                              handleDirectionChange('Descending', saveForLater)
                            }
                          />
                        </Menu.Menu>
                      </Menu>
                      {removeSavedForLaterAlertMessageId ? (
                        <Alert type="success">
                          You have successfully unsaved this{' '}
                          {removeSavedForLaterAlertMessageId}
                        </Alert>
                      ) : (
                        ''
                      )}
                      <ItemGroup divided>
                        {_.map(savedForLaterTasks, (task, index) => {
                          const continueLinkTitle =
                            `Continue working task for: ${_.get(task, 'grantId', '')} ` +
                            `${_.get(task, 'name')}`;
                          const continueLinkHref = `/tasks/${task.id}`;
                          const matchFundOpp = _.find(
                            fundingOpportunities,
                            (fundingOpportunity) => {
                              return (
                                fundingOpportunity.fundingOpportunityId ==
                                task.fundingOpportunityId
                              );
                            }
                          );
                          const fundOppName = _.get(
                            matchFundOpp,
                            'fundingOpportunityName',
                            ''
                          );
                          const viewLinkTitle = `View funding opportunity: ${fundOppName}`;
                          const viewLinkHref = `/fundingOpportunity/${matchFundOpp.fundingOpportunityId}`;
                          const viewLinkTitleOrg = `View Organization Info: ${task.organizationName}`;
                          const viewLinkHrefOrg = `/organizationProfile/${task.organizationId}`;
                          const viewLinkTitleSubOrg = `View Sub Organization Info: ${task.subOrganizationName}`;
                          const viewLinkHrefSubOrg = `/organizationProfile/${task.subOrgId}`;
                          return (
                            <Item
                              key={index}
                              className="homepage my-funding-opportunities-content"
                            >
                              <Item.Content>
                                <h4 style={{marginBottom: 3}}>
                                  <a
                                    key={`link-${
                                      task.fundingOpportunityName != null
                                        ? task.fundingOpportunityName
                                        : fundOppName
                                    }`}
                                    href="#"
                                    title={viewLinkTitle}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then(() => {
                                        setRedirect(viewLinkHref);
                                      });
                                    }}
                                  >
                                    {task.fundingOpportunityName != null
                                      ? task.fundingOpportunityName
                                      : fundOppName}
                                  </a>
                                </h4>
                                <div>
                                  Type:{' '}
                                  <span className="homepage-details">
                                    <a
                                      key={`link-${task.id}`}
                                      href="#"
                                      title={continueLinkTitle}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        new Promise((resolve) => resolve()).then(() => {
                                          setRedirect(continueLinkHref);
                                        });
                                      }}
                                    >
                                      {_.get(task, 'name', '')}
                                    </a>
                                  </span>
                                </div>
                                {task.subGrantId
                                  ? 'Subgrant ID: '
                                  : task.payload &&
                                    task.payload.scopeOfWork &&
                                    task.payload.scopeOfWork.proposedActivityTitle
                                  ? 'Title: '
                                  : 'Grant ID: '}
                                <span className="homepage-details">
                                  {task.subGrantId
                                    ? task.subGrantId
                                    : task.payload &&
                                      task.payload.scopeOfWork &&
                                      task.payload.scopeOfWork.proposedActivityTitle
                                    ? task.payload.scopeOfWork.proposedActivityTitle
                                    : task.grantId}
                                </span>
                                <br />
                                <div>
                                  Recipient:{' '}
                                  <a
                                    key={`link-${task.organizationId}`}
                                    href="#"
                                    title={viewLinkTitleOrg}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then(() => {
                                        setRedirect(viewLinkHrefOrg);
                                      });
                                    }}
                                  >
                                    <span className="homepage-details">
                                      {_.get(task, 'organizationName', '')}
                                    </span>
                                  </a>
                                </div>
                                {task.subOrgId !== undefined ? (
                                  <div>
                                    Subrecipient:{' '}
                                    <a
                                      key={`link-${task.subOrgId}`}
                                      href="#"
                                      title={viewLinkTitleSubOrg}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        new Promise((resolve) => resolve()).then(() => {
                                          setRedirect(viewLinkHrefSubOrg);
                                        });
                                      }}
                                    >
                                      <span className="homepage-details">
                                        {_.get(task, 'subOrganizationName', '')}
                                      </span>
                                    </a>
                                  </div>
                                ) : (
                                  ''
                                )}
                                <div style={{marginTop: 15}}>
                                  <a
                                    key={`link-${task.id}`}
                                    href="#"
                                    title={task.id}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      new Promise((resolve) => resolve()).then(() => {
                                        removeSavedForLater(task.sflId);
                                      });
                                      setRemoveSavedForLaterAlertMessageId(
                                        task.fundingOpportunityName != null
                                          ? task.fundingOpportunityName
                                          : fundOppName
                                      );
                                    }}
                                  >
                                    Remove
                                  </a>
                                </div>
                              </Item.Content>
                            </Item>
                          );
                        })}
                      </ItemGroup>
                      <Pagination
                        activePage={activePage}
                        totalPages={Math.ceil(totalSavedForLaterTasks / 10)}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  ) : removeSavedForLaterAlertMessageId ? (
                    <>
                      <Alert type="success">
                        You have successfully unsaved this{' '}
                        {removeSavedForLaterAlertMessageId}
                      </Alert>
                      <p style={{fontWeight: 400}}>There are no Saved tasks</p>
                    </>
                  ) : (
                    <p style={{fontWeight: 400}}>There are no Saved tasks</p>
                  )}
                </div>
              )}
            </Tab.Pane>
          ),
        }
      );
    setPanes(pane);
  }, [
    fundingOpportunities,
    assignedOpenTasks,
    activeItem,
    sortingDirection,
    loading,
    activePage,
    activeItemSaveLater,
    sortingDirectionSaveLater,
    userSavedForLater,
    removeSavedForLaterAlertMessageId,
  ]);

  const removeSavedForLater = (id) => {
    REST.dynamicData.unsaveForLater(id).then((res) => {
      if (res.ok) {
        retrieveUserSavedForLater();
      }
    });
  };

  const handleItemClick = (name, tabPane) => {
    tabPane == openTasks ? setActiveItem(name) : setActiveItemSaveLater(name);
  };

  const handleDirectionChange = (name, tabPane) => {
    tabPane == openTasks ? setSortingDirection(name) : setSortingDirectionSaveLater(name);
  };

  const handlePageChange = (e, {activePage}) => {
    setActivePage(activePage);
  };

  const sortAssignedTasks = () => {
    let sortedTasks = _.cloneDeep(assignedOpenTasks);

    switch (activeItem) {
      case 'Task':
        sortedTasks = _.sortBy(sortedTasks, 'name');
        break;
      case 'Funding opportunity name':
        sortedTasks = _.sortBy(sortedTasks, 'fundingOpportunityName');
        break;
      case 'Organization':
        sortedTasks = _.sortBy(sortedTasks, 'organizationName');
        break;
      case 'Suborganization':
        sortedTasks = _.sortBy(sortedTasks, 'subOrganizationName');
        break;
      case 'Date in queue':
        sortedTasks = _.sortBy(sortedTasks, 'created');
        break;
      case 'Grant ID':
        sortedTasks = _.sortBy(sortedTasks, 'grantId');
        break;
      case 'Subgrant ID':
        sortedTasks = _.sortBy(sortedTasks, 'subGrantId');
        break;
      case 'Priority Rank':
        sortedTasks = _.sortBy(sortedTasks, 'priority');
        break;
    }

    if (sortingDirection === 'Descending') sortedTasks = sortedTasks.reverse();

    return sortedTasks.slice(0, 10);
  };

  const filterSavedForLater = (pageNumber) => {
    let filteredTasks = [];
    userSavedForLater.forEach((saved) => {
      if (saved.dataType === 'task') {
        const matchingTask = _.find(assignedOpenTasks, (assigned) => {
          return assigned.id === saved.taskId;
        });
        if (matchingTask != undefined) {
          matchingTask.sflId = saved.id;
          filteredTasks.push(matchingTask);
        }
      }

      return filteredTasks;
    });

    switch (activeItemSaveLater) {
      case 'Task':
        filteredTasks = _.sortBy(filteredTasks, 'name');
        break;
      case 'Funding opportunity name':
        filteredTasks = _.sortBy(filteredTasks, 'fundingOpportunityName');
        break;
      case 'Organization':
        filteredTasks = _.sortBy(filteredTasks, 'organizationName');
        break;
      case 'Suborganization':
        filteredTasks = _.sortBy(filteredTasks, 'subOrganizationName');
        break;
      case 'Date in queue':
        filteredTasks = _.sortBy(filteredTasks, 'created');
        break;
      case 'Grant ID':
        filteredTasks = _.sortBy(filteredTasks, 'grantId');
        break;
      case 'Subgrant ID':
        filteredTasks = _.sortBy(filteredTasks, 'subGrantId');
        break;
      case 'Priority Rank':
        filteredTasks = _.sortBy(filteredTasks, 'priority');
        break;
    }

    if (sortingDirectionSaveLater === 'Descending')
      filteredTasks = filteredTasks.reverse();

    return filteredTasks.slice(pageNumber * 10 - 10, pageNumber * 10);
  };

  return (
    <>
      {redirect ? (
        <Redirect push to={redirect} />
      ) : (
        <Grid.Column width={9} className="homepage homepage-grid">
          <Grid.Row>
            <h3>My work</h3>
          </Grid.Row>
          <Card fluid>
            <Card.Content id="homepage-link">
              <Tab
                menu={{color: 'blue', secondary: true, pointing: true}}
                panes={panes}
                onTabChange={(e) => {
                  setRemoveSavedForLaterAlertMessageId(null);
                }}
              />
            </Card.Content>
          </Card>
        </Grid.Column>
      )}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    toggles: state.toggles.toggles,
  };
};

export default connect(mapStateToProps, null)(FemaWorkCard);
